import { useEffect, useState } from 'react'

export function useIsVisible(ref: React.RefObject<Element>) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting)
    })
    if (!ref.current) return

    observer.observe(ref.current as Element)
    return () => {
      observer.disconnect()
    }
  }, [ref])

  return isIntersecting
}
